package `fun`.adaptive.document.model

abstract class DocInlineElement : DocElement()